export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <span className="text-xl font-heading font-bold text-primary-400 whitespace-nowrap">
              90影视
            </span>
            <p className="mt-3 text-sm text-white/50 leading-relaxed max-w-[260px]">
              高清电影电视剧免费在线观看平台，海量影视资源每日更新，支持APP下载，安全访问畅享观影。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '首页', href: '#hero' },
                { label: '最新动态', href: '#updates' },
                { label: '专题聚焦', href: '#carousel' },
                { label: '热门话题', href: '#topics' },
                { label: '影视索引', href: '#index' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="text-sm text-white/45 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-4">服务支持</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: 'APP下载', href: '#app' },
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: '关于我们', href: '#about' },
                { label: '用户评价', href: '#comments' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="text-sm text-white/45 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-4">合作伙伴</h4>
            <p className="text-sm text-white/35 leading-relaxed">
              感谢所有合作伙伴的支持与信任，我们将持续为广大用户提供优质的影视观看服务。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/35 text-center sm:text-left">
            &copy; {new Date().getFullYear()} 90影视. 本站内容仅供学习交流，请勿用于商业用途。
          </p>
          <div className="flex items-center gap-4 text-xs text-white/35">
            <span>90影视官网入口</span>
            <span className="hidden sm:inline">|</span>
            <span>高清电影电视剧免费在线观看</span>
          </div>
        </div>
      </div>
    </footer>
  );
}